import { CheckmarkCircleFilledIcon } from '@calizahq/react-components-v2'
import React from 'react'

import { HomeQualityCheckInspectionStatus, HomeQualityCheckInspectionSummary } from '@/types/HomeQualityCheck'

export const HomeQualityCheckInspectionLocationSummary = ({
  inspection,
  setHomeLocation,
}: {
  inspection: HomeQualityCheckInspectionSummary
  setHomeLocation: (homeLocation?: string) => void
}) => {
  return (
    <div
      className={`rounded-xl ${
        inspection.status === HomeQualityCheckInspectionStatus.COMPLETED ? 'bg-green-100' : 'bg-action-secondary'
      } px-4 py-3`}
    >
      <div className="flex items-center">
        <p
          className={`font-medium text-p-md ${
            inspection.status === HomeQualityCheckInspectionStatus.COMPLETED ? 'text-semantic-success' : ''
          }`}
        >
          {inspection.homeLocation}
        </p>
        {inspection.status === HomeQualityCheckInspectionStatus.COMPLETED ? (
          <CheckmarkCircleFilledIcon className="ml-2 mr-4 h-5 text-green-300" />
        ) : null}
      </div>
      <button
        className="font-bold text-p-sm underline text-semantic-success"
        onClick={() => setHomeLocation(inspection.homeLocation)}
      >
        {inspectionPrompt(inspection.status)}
      </button>
    </div>
  )
}

const inspectionPrompt = (status: HomeQualityCheckInspectionStatus): string => {
  switch (status) {
    case HomeQualityCheckInspectionStatus.PENDING:
      return 'Start'
    case HomeQualityCheckInspectionStatus.STARTED:
      return 'Continue'
    case HomeQualityCheckInspectionStatus.COMPLETED:
      return 'Review'
    default:
      return 'Review'
  }
}
